const steps = [
  {
    number: '01',
    icon: 'ri-search-line',
    title: 'Browse & Choose',
    description: 'Open the Sweetplate app, search for your favourite dish or browse top-rated restaurants near you.',
    color: 'bg-[#009E81]',
  },
  {
    number: '02',
    icon: 'ri-shopping-bag-3-line',
    title: 'Place Your Order',
    description: 'Add items to your cart, confirm your address, and pay securely with card, wallet, or Sweetplate tokens.',
    color: 'bg-[#FFCD1A]',
  },
  {
    number: '03',
    icon: 'ri-e-bike-2-line',
    title: 'Fast Delivery',
    description: 'A verified rider picks up your order and delivers it in under an hour — track every step live on the map.',
    color: 'bg-[#FF7B54]',
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-white py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-[#E6F7F4] text-[#009E81] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            How It Works
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Order in 3 simple steps
          </h2>
          <p className="mt-4 text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Getting your favourite meal delivered has never been this easy.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {/* Connector line — desktop only */}
          <div className="absolute top-12 left-1/6 right-1/6 h-px bg-gradient-to-r from-[#009E81] via-[#FFCD1A] to-[#FF7B54] hidden md:block" />

          {steps.map((step) => (
            <div
              key={step.number}
              className="relative flex flex-col items-center text-center group"
            >
              <div
                className={`relative z-10 w-20 h-20 md:w-24 md:h-24 rounded-full ${step.color} flex items-center justify-center mb-5 transition-transform duration-300 group-hover:-translate-y-2`}
              >
                <i className={`${step.icon} text-2xl md:text-3xl text-white`} />
                <span className="absolute -top-2 -right-2 bg-white border-2 border-gray-100 text-gray-900 text-xs font-black w-7 h-7 rounded-full flex items-center justify-center">
                  {step.number}
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-xs">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
